var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.345,
    height: 9.033,
    viewBox: "0 0 11.345 9.033",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M13.646,5.057a1.041,1.041,0,1,1,1.487,1.458L9.589,13.445a1.041,1.041,0,0,1-1.5.028L4.417,9.8A1.041,1.041,0,1,1,5.889,8.326L8.8,11.233l4.823-6.145a.328.328,0,0,1,.028-.031Z",
    transform: "translate(-4.085 -4.745)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-2.8f961480f7de06e5536d97c74e2d0ef8.svg";